import { render } from "./NavigationAction.vue?vue&type=template&id=355885a4"
import script from "./NavigationAction.vue?vue&type=script&lang=js"
export * from "./NavigationAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__